import React from 'react';

import usePlanTaskForms from '../tasks/CreateUpdate/planTaskForms';
import { ButtonSize, OptionSelectionButton } from 'ui-builder';
import { TaskType, TeamPermission } from 'nekst-api';
import { PlanPermission, useAuthorizationChecker } from 'authorization-scope';
import useFeatureToggleService from 'feature-toggle';

export default function CreateTasksButton(props: {
  id: number
}) {
  const { isGranted } = useAuthorizationChecker();
  const featureToggle = useFeatureToggleService();

  const planTaskForms = usePlanTaskForms();

  if (isGranted(PlanPermission.UPDATE)) {
    return (
      <OptionSelectionButton<TaskType>
        text="Add task"
        options={[
          {
            value: TaskType.STANDARD,
            label: 'Add standard task',
            onSelected: () => {
              planTaskForms.openCreateStandardTaskForm(props.id);
            }
          },
          {
            value: TaskType.EMAIL,
            label: 'Add email task',
            onSelected: () => {
              planTaskForms.openCreateEmailTaskForm(props.id);
            },
          },
          isGranted(TeamPermission.USE_SMS_TASKS_FEATURE) && {
            value: TaskType.SMS,
            label: 'Add SMS task',
            onSelected: () => {
              planTaskForms.openCreateSmsTaskForm(props.id);
            }
          },
          featureToggle.isEventTasksEnabled() && featureToggle.isPlanEventTasksEnabled() && {
            value: TaskType.EVENT,
            label: 'Add appointment task',
            onSelected: () => {
              planTaskForms.openCreateEventTaskForm(props.id);
            }
          }
        ]}
        size={ButtonSize.MEDIUM}
      />
    );

  } else {
    return null;
  }
}
